import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { hideSidebar } from 'redux/navigation'
import { List } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      push,
      hideSidebar,
    },
    dispatch
  )
}

class NavigationList extends React.Component {
  render() {
    const { items, push, hideSidebar, children } = this.props

    const list = items.map((item) => (
      <List.Item
        {...{
          size: 'small',
          active: item.active,
          children: children ? children : item.content,
          href: item.path,
          key: item.key,
          onClick: (event) => {
            event.preventDefault()
            push(item.path)
            hideSidebar()
          },
        }}
      />
    ))

    return <List>{list}</List>
  }
}

NavigationList = connect(mapStateToProps, mapDispatchToProps)(NavigationList)
export default NavigationList



// WEBPACK FOOTER //
// ./src/components/shared/Navigation/renditions/NavigationList.jsx